import { PRINT_STORE_DISCOUNT_UPSELL } from '../../../constants/optimizely'
import { PriceTier, ShoppingCartItem } from '@dtx-company/flow-codegen/src/code/generated.types'
import { useDiscountInfo } from '../../print-store/UpsellCTA/hooks'
import { useFlowFeature } from '@dtx-company/inter-app/src/hooks/useFlowFeature/useFlowFeature'

interface UseCartItemsPriceReturn {
  getItemPrice: (item: ShoppingCartItem) => number
}

export function useCartItemsPrice(): UseCartItemsPriceReturn {
  const { currentDiscount } = useDiscountInfo()
  const { discount } = currentDiscount ?? {}

  const [isStoreDiscountUpsellActive] = useFlowFeature(PRINT_STORE_DISCOUNT_UPSELL)
  const shouldProcessDiscountInformation = Boolean(discount && isStoreDiscountUpsellActive)

  const getPriceTier = (item: ShoppingCartItem, qty: number): PriceTier => {
    const noTier = { unitAmount: 0, quantity: 0 }
    if (!item || !qty) return noTier
    const sortedTiers = item?.product?.priceModel?.sortedTiers || []
    let priceTier = sortedTiers?.[0] || noTier
    for (let i = 1; i < sortedTiers.length; i++) {
      const tier = sortedTiers[i]
      if (tier?.quantity && qty >= tier?.quantity) {
        priceTier = tier
      } else {
        break
      }
    }
    return priceTier
  }

  const getItemPrice = (item: ShoppingCartItem): number => {
    const priceTier = getPriceTier(item, item?.quantity || 0)
    const subTotal = (item?.quantity || 0) * (priceTier?.unitAmount || 0)
    const amountDiscounted =
      shouldProcessDiscountInformation && discount ? subTotal * (discount / 100) : 0
    return subTotal - amountDiscounted
  }

  return {
    getItemPrice
  }
}
